/**
 * URL absoluta do modelo de certificado em `public/{eventId}.jpg`.
 * Evita path relativo que quebra em rotas aninhadas (ex.: /eventos/:id/certificados).
 */
export function getCertificateImageUrl(eventId: string): string {
  const base = (import.meta.env.BASE_URL || "/").replace(/\/$/, "");
  const id = String(eventId ?? "").replace(/^\/+|\/+$/g, "");
  return `${base}/${id}.jpg`;
}
